import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=39720d55&"
import script from "./ImportButton.vue?vue&type=script&lang=js&"
export * from "./ImportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports